import {CommonModule} from '@angular/common';
import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../../services/api.service';
import {RoleService} from '../../services/role.service';
import {AuthService} from '../../services/auth.service';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    faAngleLeft,
    faAngleRight,
    faCamera,
    faCheck,
    faFileExcel,
    faHdd,
    faHeartPulse,
    faMagnifyingGlass,
    faPen,
    faPenToSquare,
    faSquareCheck,
    faSquarePlus,
    faSquareXmark,
    faTrash,
    faUpload,
    faVideo,
    faXmark
} from '@fortawesome/free-solid-svg-icons';
import {getFileNameFromResponse} from '../../../common/utils';
import saveAs from 'file-saver';
import {GenericSearchComponent} from '../../shared/search-suggestion/search-suggestion.component';
import {OrganizationAvatarComponent} from '../../shared/organization-avatar/organization-avatar.component';
import {OrganizationOnboardingComponent} from '../../shared/organization-onboarding/organization-onboarding.component';
import {AddDemoAccountDialogComponent} from '../../shared/add-demo-account-dialog/add-demo-account-dialog.component';
import {formatOnboardingListLabel} from '../../shared/organization-onboarding/organization-onboarding.utils';
import {resolveOrganizationProfilePicUrl} from '../../shared/organization-profile.utils';
import {DEFAULT_TABLE_PAGE_SIZE_OPTIONS} from '../../shared/constants/pagination.constants';
import {ReportingDatePipe} from '../../shared/datetime/reporting-date.pipe';
import {VtePaginationComponent} from '../../shared/vte/vte-pagination/vte-pagination.component';


@Component({
    selector: 'app-organization',
    imports: [CommonModule, FontAwesomeModule, ReactiveFormsModule, FormsModule, GenericSearchComponent, OrganizationAvatarComponent, OrganizationOnboardingComponent, AddDemoAccountDialogComponent, ReportingDatePipe, VtePaginationComponent],
    templateUrl: './organization.component.html',
    styleUrl: './organization.component.css'
})
export class OrganizationComponent {
    readonly pageSizeOptions = DEFAULT_TABLE_PAGE_SIZE_OPTIONS;
  activeTab: string = 'organization'; // Default active tab
  
  cusSearchText: string | null = '';
  staffSearchText: string | null = '';
  staffRecordsPerPage: number = 10;
  staffCurrentPage: number = 1;
  userDetail:any = []; 
  staffNxtPage: number | null = null;
  staffPrePage: number | null = null;
  staffOrganizations: any[] = [];
    showDemoAccountDialog = false;
  staffOrganizationId: string = '';
  limit: number = 10;
  showConfirmationDialog: boolean = false;
    showStaffStatusDialog = false;
    staffStatusTarget: any = null;
    staffStatusNextValue = true;
    staffStatusLoading = false;
    expandedStaffUserId: number | null = null;
    currentUserId: number | null = null;
  pId: number = 0;
  staffRecordCount:number = 0
  orgId:number = 0;
  isEditing: Boolean = false;
  organizationDetail: any = {
    name: '',
    address: {},
    is_active: false,
      profile_pic: null,
      profile_pic_url: null
  };
  role: string ='';
    isPlatformSuperuser = false;
  organizationForm!: FormGroup;
  // customer var
  cusRecordsPerPage: number = 10;
  cusCurrentPage: number = 1;
  cusNxtPage: number | null = null;
  cusPrePage: number | null = null;
  // limit: number = 10;
  cusRecordCount:number = 0
  customerArray:any = [];
  isFrom = ''
    customerOnboardingOrdering: '' | 'onboarding' | '-onboarding' = '';
    customerAccountTypeOrdering: '' | 'account_type' | '-account_type' = '';
    formatOnboardingListLabel = formatOnboardingListLabel;
  selectedFile: File | null = null;
    private profilePicPreviewUrl: string | null = null;
  hoveredRowId: number | null = null;
    showActiveCustomersOnly = false;

  

  constructor(private apiService: ApiService,
              library: FaIconLibrary,
              private router: Router,
              private route: ActivatedRoute,
              private roleService: RoleService,
              private authService: AuthService,
              private toastr:ToastrService,
              private fb: FormBuilder) {
    this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
    this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
    this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage);
    library.addIcons(faTrash,
                    faFileExcel,
                    faAngleRight,
                    faAngleLeft,
                    faUpload,
                    faSquarePlus,
                    faMagnifyingGlass,
                    faPen,
                    faPenToSquare,
                    faXmark,
                    faCheck,
                    faSquareCheck,
                    faSquareXmark,
                    faCamera,
        faVideo,
        faHdd,
        faHeartPulse,
                    
                  );
    
    let user = localStorage.getItem('user');
    if (user){
      const userObj = JSON.parse(user)
        this.orgId = userObj['org_id'] ?? userObj['orgId']
      this.role = userObj['groups']
        this.isPlatformSuperuser = this.authService.isSuperUser();
        this.currentUserId = userObj['id'] ?? null;
    }
      if (this.isInternalUser()) {
      this.fetchStaffOrganizations();
    }

    const navigation = this.router.getCurrentNavigation();
    const requestedTab = navigation?.extras.state?.['activeTab'];
    if (requestedTab && this.canActivateOrganizationTab(requestedTab)) {
      this.activeTab = requestedTab;
    }
      this.applyRouteTab(this.route.snapshot.queryParamMap);
      this.route.queryParamMap.subscribe((params) => this.applyRouteTab(params));
    this.getOrganization()
    
  }

    isInternalUser(): boolean {
        const roles = Array.isArray(this.role) ? this.role : [this.role];
        return this.roleService.canAccessOrganizationsListing(roles);
    }

    canViewOrganizationsTab(): boolean {
        return this.isInternalUser();
    }

    /**
     * Customer-tab organization mutations (toggles, delete, export, add).
     * Sales Managers may list/open profiles but cannot mutate or export (N-01 follow-up).
     * Platform Super User retains existing management controls.
     */
    canMutateCustomerOrganizations(): boolean {
        return this.isPlatformSuperuser;
    }

    /**
     * Customer-row Camera shortcut to /view-cameras (org-scoped inventory).
     * Visible for platform Super User (CameraManagementAccessGuard) and
     * Admin/Member CoreOps users. Hidden for Sales Manager (N-01).
     */
    canViewCustomerRowCameras(): boolean {
        if (this.isPlatformSuperuser) {
            return true;
        }
        return !this.roleService.isSalesManager(this.role);
    }

    /**
     * Customer-row Bridge shortcut to /view-bridges (P22-05 read access).
     * Super User + Admin/Member; Sales Manager denied.
     */
    canViewCustomerRowBridges(): boolean {
        return this.roleService.canAccessBridgeManagement(this.role);
    }

    /**
     * Staff administration tab: Admin, Member, or platform Super User.
     * Sales Managers may list/view organizations but must not open staff admin
     * via the tab button, query params, or navigation state (N-01 Batch 2 Fix 1).
     */
    canAccessStaffTab(): boolean {
        if (this.isPlatformSuperuser) {
            return true;
        }
        return this.roleService.isAdmin(this.role) || this.roleService.isMember(this.role);
    }

    canActivateOrganizationTab(tab: string): boolean {
        if (tab === 'staff') {
            return this.canAccessStaffTab();
        }
        if (tab === 'customer') {
            return this.canViewOrganizationsTab();
        }
        if (tab === 'camera') {
            return this.roleService.isAdmin(this.role) || this.roleService.isMember(this.role);
        }
        // Default organization profile tab (and unknown tabs treated as profile).
        return tab === 'organization' || !tab;
    }

    applyRouteTab(params: { get: (key: string) => string | null }): void {
        const tab = params.get('tab');
        if (tab === 'customer' && this.canViewOrganizationsTab()) {
            this.activeTab = 'customer';
            this.showActiveCustomersOnly = params.get('active') === 'true';
            if (this.activeTab === 'customer') {
                this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
            }
            return;
        }
        if (tab === 'staff') {
            if (this.canAccessStaffTab()) {
                this.activeTab = 'staff';
            } else if (this.activeTab === 'staff') {
                // Clear a previously forced staff tab (e.g. navigation state) for unauthorized roles.
                this.activeTab = 'organization';
            }
            return;
        }
    }

  selectTab(tab: string): void {
    if (!this.canActivateOrganizationTab(tab)) {
      return;
    }
    this.activeTab = tab;
  }

  // Staff Tab
  addStaff() {
    this.router.navigate(['signup']);
  }

    addDemoStaff() {
        this.showDemoAccountDialog = true;
    }

    closeDemoAccountDialog() {
        this.showDemoAccountDialog = false;
    }

    onDemoAccountCreated() {
        this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
    }

    canToggleStaffStatus(record: any): boolean {
        return this.isPlatformSuperuser && record?.id !== this.currentUserId && !record?.is_superuser;
    }

    get staffTableColumnCount(): number {
        return 8;
    }

    isStaffRowExpanded(record: any): boolean {
        return this.expandedStaffUserId != null && this.expandedStaffUserId === record?.id;
    }

    toggleStaffRowExpand(record: any, event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        if (!this.isPlatformSuperuser || !record?.id) {
            return;
        }
        this.expandedStaffUserId = this.isStaffRowExpanded(record) ? null : record.id;
    }

    staffMobileVerificationLabel(record: any): string {
        return record?.is_mobile_verified ? 'Verified' : 'Not Verified';
    }

    staffEmailVerificationLabel(record: any): string {
        return record?.is_email_verified ? 'Verified' : 'Not Verified';
    }

    staffAccountStatusLabel(record: any): string {
        if (record?.is_active === false) {
            // Pending invite/activation has no disable reason; manual/demo disable does.
            return record?.disabled_reason ? 'Disabled' : 'Inactive';
        }
        return 'Active';
    }

    openStaffStatusDialog(record: any, nextValue: boolean, event: Event) {
        event.preventDefault();
        event.stopPropagation();
        if (!this.canToggleStaffStatus(record)) {
            return;
        }
        this.staffStatusTarget = record;
        this.staffStatusNextValue = nextValue;
        this.showStaffStatusDialog = true;
    }

    closeStaffStatusDialog() {
        if (this.staffStatusLoading) {
            return;
        }
        this.showStaffStatusDialog = false;
        this.staffStatusTarget = null;
    }

    confirmStaffStatusChange() {
        if (!this.staffStatusTarget?.id) {
            return;
        }
        this.staffStatusLoading = true;
        this.apiService.toggleStaffActive(this.staffStatusTarget.id, this.staffStatusNextValue).subscribe({
            next: () => {
                this.toastr.success(
                    this.staffStatusNextValue ? 'Staff account enabled.' : 'Staff account disabled.',
                    'Success'
                );
                this.staffStatusLoading = false;
                this.closeStaffStatusDialog();
                this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
            },
            error: (err) => {
                this.staffStatusLoading = false;
                if (err?.error?.detail) {
                    this.toastr.error(err.error.detail, 'Error');
                } else if (err?.status !== 403 && err.status !== 0) {
                    this.toastr.error('Unable to update staff status.', 'Error');
                }
                this.closeStaffStatusDialog();
                this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
            }
        });
    }

  fetchUserData(page: number, pageSize: number){
      const orgId = this.isInternalUser() ? this.staffOrganizationId || null : null;
    this.apiService.getUserdetail(page, pageSize, this.staffSearchText, orgId).subscribe((data:any) => {

      this.userDetail = data['results'];
      this.staffRecordCount = data['count'];
      this.staffNxtPage = data['next'];
      this.staffPrePage = data['previous'];
        this.expandedStaffUserId = null;

    });
  }
  fetchStaffOrganizations() {
    this.apiService.getOrganizations().subscribe((data: any) => {
      if (Array.isArray(data?.results)) {
        this.staffOrganizations = data.results;
        return;
      }
      if (data && typeof data === 'object') {
        this.staffOrganizations = Object.entries(data).map(([id, name]) => ({ id, name }));
        return;
      }
      this.staffOrganizations = [];
    });
  }
  onStaffOrganizationChange() {
    this.staffCurrentPage = 1;
    this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
  }

  get staffTotalPages(): number {
    let totalPage = Math.ceil(this.staffRecordCount / this.staffRecordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  next() {
    if (this.staffNxtPage){
      this.staffCurrentPage++;
      this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage)
    }
  }

  previous() {
    if (this.staffPrePage){
      this.staffCurrentPage--;
      this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage)
      }
  }

  selectPageSize(){
    if(this.staffRecordsPerPage){
      // debugger;
      this.staffCurrentPage = 1;
      this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage)
    }
  }

    onStaffPageChange(page: number): void {
        this.staffCurrentPage = page;
        this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
    }

    onStaffPageSizeChange(pageSize: number): void {
        this.staffRecordsPerPage = pageSize;
        this.staffCurrentPage = 1;
        this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
    }
  staffExportToExcel(){
      const orgId = this.isInternalUser() ? this.staffOrganizationId || null : null;
    this.apiService.exportStaff(this.staffCurrentPage, this.staffRecordsPerPage, this.staffSearchText, orgId).subscribe({
        next: (response: any) => {
          const fileName = getFileNameFromResponse(response);
            if (response.body) {
                saveAs(response.body, fileName);
            }
          
        },
        error: (err) => {
          this.toastr.error(`${err}`, 'Error')
        }
      })
  }
  openConfirmationDialog(index: number, from: string) {
    this.showConfirmationDialog = true;
    this.pId = index;
    this.isFrom = from
  }

  closeConfirmationDialog() {
    this.showConfirmationDialog = false;
  }

  confirmDelete() {
    if (this.isFrom === "staff"){
      this.apiService.deleteUser(this.pId).subscribe({
        next: (response:any) => {
          this.toastr.success('User is deleted successfully.', 'Success');
          this.closeConfirmationDialog();
          this.fetchUserData(this.staffCurrentPage, this.staffRecordsPerPage);
        },
        error: (err) => {
          if (err['error']['detail']) {
              this.toastr.error(err['error']['detail'], 'Error');
            
          }  else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }
          this.closeConfirmationDialog();
        }
      })
    }else if(this.isFrom === "customer"){
      this.apiService.deleteOrganization(this.pId).subscribe({
        next: (response:any) => {
          this.toastr.success('Customer is deleted successfully.', 'Success');
          this.closeConfirmationDialog();
          this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
        },
        error: (err) => {
          if (err['error']['detail']) {
              this.toastr.error(err['error']['detail'], 'Error');
            
          }  else if (err['status'] !== 403 && err.status !== 0) {
            this.toastr.error("Something went wrong!", 'Error');
          }
          this.closeConfirmationDialog();
        }
      })
    }
    

  }

  updateUser(pk: number){
    this.router.navigate([`/profile/edit/${pk}`])
   
  }
  
  UserSearch(){
  }


  // Organization code

  getOrganization(){
      if (!this.orgId) {
          return;
      }
    this.apiService.getOrganization(this.orgId).subscribe({
      next: (response: any) => {
        this.organizationDetail = response
          this.applyProfilePicFromResponse(response);
      },
      error: (err) => {
        if (err['error']['non_field_errors']) {
          err['error']['non_field_errors'].forEach((element:any) => {
            this.toastr.error(element, 'Error');
          });
        }  else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error("Something went wrong!.", 'Error');
        }
      }
    });
  }

  onPincodeChange() {
    const pincode = this.organizationForm.get('pincode')?.value;

    if (pincode && pincode.length === 6) { // Adjust length validation based on your region
      this.fetchCityState(pincode);
    }
  }

  fetchCityState(pincode: number){
    this.apiService.getCityState(pincode).subscribe({
      next: (data: any) => {
        if (data.length > 0){
          data = data[0]
          this.organizationForm.patchValue({
            city: data.district_name,
            state: data.state_name,
            // locality: data.village_or_locality_name,
          });
        }
        
        
      },
      error: (err) => {
        if (err['error']['detail']) {
          this.toastr.error(err['error']['detail'], 'Error')
        }  else if (err['status'] !== 403 && err.status !== 0) {
          this.toastr.error('Something went wrong while fetching city & state, please try again', 'Error');
        }
      }
    });
  }

  // Update onFileSelected method
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files[0]) {
      const file = input.files[0];
      
      // Validate file type
        const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];
      if (!allowedTypes.includes(file.type)) {
        this.toastr.error('Please upload only image files (JPG, PNG, GIF, WEBP)', 'Invalid File');
        return;
      }

      // Validate file size (e.g., 5MB max)
      const maxSize = 5 * 1024 * 1024; // 5MB in bytes
      if (file.size > maxSize) {
        this.toastr.error('File size should be less than 5MB', 'File Too Large');
        return;
      }

      this.selectedFile = file;
        this.setProfilePicPreview(file);

      // Upload immediately
      this.uploadImage(file);
    }
  }

  // Add new method for image upload
  uploadImage(file: File) {
    const formData = new FormData();
    formData.append('profile_pic', file);

    this.apiService.editOrganization(this.orgId, formData).subscribe({
      next: (res: any) => {
        this.toastr.success('Profile picture updated successfully', 'Success');
          this.applyProfilePicFromResponse(res, true);
      },
      error: (err) => {
        this.toastr.error(this.getBackendErrorMessage(err) || 'Failed to upload profile picture', 'Error');
        // Revert to previous image
       this.getOrganization()
      }
    });
  }

  private getBackendErrorMessage(err: any): string {
    const error = err?.error;
    if (!error) {
      return '';
    }
    if (typeof error.detail === 'string') {
      return error.detail;
    }
    if (Array.isArray(error.profile_pic) && error.profile_pic.length) {
      return error.profile_pic.join(' ');
    }
    return '';
  }

    deleteProfileImage() {
        this.apiService.editOrganization(this.orgId, {profile_pic: null}).subscribe({
            next: (res: any) => {
                this.toastr.success('Profile picture removed successfully', 'Success');
                this.clearProfilePicPreview();
                this.applyProfilePicFromResponse(res);
            },
            error: (err) => {
                this.toastr.error(this.getBackendErrorMessage(err) || 'Failed to remove profile picture', 'Error');
            }
        });
    }

    refreshOrganizationProfileImage() {
        this.getOrganization();
    }

    private setProfilePicPreview(file: File): void {
        this.clearProfilePicPreview();
        this.profilePicPreviewUrl = URL.createObjectURL(file);
        this.organizationDetail.profile_pic_url = this.profilePicPreviewUrl;
    }

    private clearProfilePicPreview(): void {
        if (this.profilePicPreviewUrl) {
            URL.revokeObjectURL(this.profilePicPreviewUrl);
            this.profilePicPreviewUrl = null;
        }
    }

    private applyProfilePicFromResponse(response: any, refetchIfMissing = false): void {
        const resolved = resolveOrganizationProfilePicUrl(response);
        if (resolved) {
            this.clearProfilePicPreview();
            this.organizationDetail.profile_pic_url = resolved;
            return;
        }
        if (refetchIfMissing) {
            this.getOrganization();
            return;
        }
        if (!this.profilePicPreviewUrl) {
            this.organizationDetail.profile_pic_url = null;
        }
    }

    private resolveProfilePic(response: any): string | null {
        return resolveOrganizationProfilePicUrl(response);
    }

  toggleEdit() {
   this.router.navigate(['/organization/edit'])
  }

  onCancel() {
    window.location.reload();

  }

  // Customer tab

  addCustomer() {
    this.router.navigate(['organization/add']);
  }
  fetchCustomerData(page: number, pageSize: number){
      const ordering = this.customerAccountTypeOrdering || this.customerOnboardingOrdering || null;
      this.apiService.getAllOrganization(page, pageSize, this.cusSearchText, ordering).subscribe((data: any) => {
        let results = data['results'] || [];
        if (this.showActiveCustomersOnly) {
            results = results.filter((org: any) => org.is_active);
        }
        this.customerArray = results;
        this.cusRecordCount = this.showActiveCustomersOnly ? results.length : data['count'];
      this.cusNxtPage = data['next']
      this.cusPrePage = data['previous']

    });
  }

  get cusTotalPages(): number {
    let totalPage = Math.ceil(this.cusRecordCount / this.cusRecordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  cusNext() {
    if (this.cusNxtPage){
      this.cusCurrentPage++;
      this.fetchUserData(this.cusCurrentPage, this.cusRecordsPerPage)
    }
  }

  cusPrevious() {
    if (this.cusPrePage){
      this.cusCurrentPage--;
      this.fetchUserData(this.cusCurrentPage, this.cusRecordsPerPage)
      }
  }

  cusSelectPageSize(){
    if(this.cusRecordsPerPage){
      // debugger;
      this.cusCurrentPage = 1;
      this.fetchUserData(this.cusCurrentPage, this.cusRecordsPerPage)
    }
  }

  customerExportToExcel(){
  this.apiService.exportOraganization(this.cusCurrentPage, this.cusRecordsPerPage, this.cusSearchText).subscribe({
      next: (response: any) => {
        const fileName = getFileNameFromResponse(response);
          if (response.body) {
              saveAs(response.body, fileName);
          }
        
      },
      error: (err) => {
        this.toastr.error(`${err}`, 'Error')
      }
    })
  }

  updateCustomer(pk: number){
    this.router.navigate(['/organization', pk, 'profile']);
   
  }

    toggleCustomerOnboardingSort(): void {
        if (this.customerOnboardingOrdering === '') {
            this.customerOnboardingOrdering = 'onboarding';
        } else if (this.customerOnboardingOrdering === 'onboarding') {
            this.customerOnboardingOrdering = '-onboarding';
        } else {
            this.customerOnboardingOrdering = 'onboarding';
        }
        this.customerAccountTypeOrdering = '';
        this.cusCurrentPage = 1;
        this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
    }

    toggleCustomerAccountTypeSort(): void {
        if (this.customerAccountTypeOrdering === '') {
            this.customerAccountTypeOrdering = 'account_type';
        } else if (this.customerAccountTypeOrdering === 'account_type') {
            this.customerAccountTypeOrdering = '-account_type';
        } else {
            this.customerAccountTypeOrdering = 'account_type';
        }
        this.customerOnboardingOrdering = '';
        this.cusCurrentPage = 1;
        this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
    }
  
  customerSearch(){
  }

  addCamera(id:number, name: string){

    this.router.navigate(['/add-camera'], { queryParams: {'id': id, 'name': name}})

  }
  viewCamera(id: number, name: string){
    this.router.navigate(['/view-cameras'], { queryParams: {'id': id, 'name': name}})

  }

    viewBridge(id: number, name: string) {
        this.router.navigate(['/view-bridges'], {queryParams: {'id': id, 'name': name}})
    }

    viewDeviceHealth(id?: number, name?: string) {
        if (id != null) {
            this.router.navigate(['/device-health'], {queryParams: {id, name: name || ''}});
            return;
        }
        this.router.navigate(['/device-health']);
    }

  


  cameraData:any = [];
  cameraNxtPage: number | null = null;
  cameraPrePage: number | null = null;
  cameraRecordCount: number = 0;
  cameraSearchText: string = '';
  cameraRecordsPerPage: number = 10;
  cameraCurrentPage: number = 1;

  fetchCameraData(page: number, pageSize: number){
    this.apiService.viewCameras(page, pageSize, this.cameraSearchText).subscribe({
      next: (data: any) => {
      this.cameraData = data['results'];
      this.cameraRecordCount = data['count'];
      this.cameraNxtPage = data['next']
      this.cameraPrePage = data['previous']
    }
  });
  }

  get cameraTotalPages(): number {
    let totalPage = Math.ceil(this.cameraRecordCount / this.cameraRecordsPerPage);
      if (totalPage === 0){
        totalPage = 1;
      }
      return totalPage;
    }

  cameraNext() {
    if (this.cameraNxtPage){
      this.cameraCurrentPage++;
      this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage)
    }
  }

  cameraPrevious() {
    if (this.cameraPrePage){
      this.cameraCurrentPage--;
      this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage)
      }
  }

  cameraSelectPageSize(){
    if(this.cameraRecordsPerPage){
      this.cameraCurrentPage = 1;
      this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage)
    }
  }

    onCameraPageChange(page: number): void {
        this.cameraCurrentPage = page;
        this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage);
    }

    onCameraPageSizeChange(pageSize: number): void {
        this.cameraRecordsPerPage = pageSize;
        this.cameraCurrentPage = 1;
        this.fetchCameraData(this.cameraCurrentPage, this.cameraRecordsPerPage);
    }

    onCustomerPageChange(page: number): void {
        this.cusCurrentPage = page;
        this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
    }

    onCustomerPageSizeChange(pageSize: number): void {
        this.cusRecordsPerPage = pageSize;
        this.cusCurrentPage = 1;
        this.fetchCustomerData(this.cusCurrentPage, this.cusRecordsPerPage);
    }
  cameraExportToExcel(){
    this.apiService.exportCamera(this.cameraCurrentPage, this.cameraRecordsPerPage, this.cameraSearchText).subscribe({
        next: (response: any) => {
          const fileName = getFileNameFromResponse(response);
            if (response.body) {
                saveAs(response.body, fileName);
            }
          
        },
        error: (err) => {
          this.toastr.error(`${err}`, 'Error')
        }
      })
  }

  onUserResults(event: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
    this.staffCurrentPage = 1;
    this.staffRecordsPerPage = 10;
    this.staffPrePage = event.previousPage;
    this.staffNxtPage = event.nextPage;
    this.staffSearchText = event.searchText;
    this.userDetail = event.results;
    this.staffRecordCount = event.totalRecords;
      this.expandedStaffUserId = null;
  };
  onCustomerResults(customerEvent: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
    this.cusCurrentPage = 1;
    this.cusRecordsPerPage = 10;
    this.cusPrePage = customerEvent.previousPage;
    this.cusNxtPage = customerEvent.nextPage;
    this.cusSearchText = customerEvent.searchText;
    this.customerArray = customerEvent.results;
    this.cusRecordCount = customerEvent.totalRecords;
  };
  onCameraResults(cameraEvent: { searchText: string, results: any[], totalRecords: number, nextPage: number | null, previousPage: number | null }) {
    this.cameraCurrentPage = 1;
    this.cameraRecordsPerPage = 10;
    this.cameraPrePage = cameraEvent.previousPage;
    this.cameraNxtPage = cameraEvent.nextPage;
    this.cameraSearchText = cameraEvent.searchText;
    this.cameraData = cameraEvent.results;
    this.cameraRecordCount = cameraEvent.totalRecords;
  };

  toggleSubscription(record: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const nextValue = input.checked;
    const previousValue = record.subscription_enabled;
    record.subscription_loading = true;
    record.subscription_enabled = nextValue;

    this.apiService.editOrganization(record.id, { subscription_enabled: nextValue }).subscribe({
      next: (response: any) => {
        record.subscription_enabled = response.subscription_enabled;
        record.subscription_loading = false;
        this.toastr.success('Subscription status updated.', 'Success');
      },
      error: (err) => {
        record.subscription_enabled = previousValue;
        record.subscription_loading = false;
        if (err?.error?.detail) {
          this.toastr.error(err.error.detail, 'Error');
        } else if (err?.error?.subscription_enabled) {
          this.toastr.error(err.error.subscription_enabled, 'Error');
        } else {
          this.toastr.error('Unable to update subscription status.', 'Error');
        }
      }
    });
  }

  toggleVisitorManagement(record: any, event: Event) {
    const input = event.target as HTMLInputElement;
    const nextValue = input.checked;
    const previousValue = record.visitor_management_enabled;
    record.visitor_management_loading = true;
    record.visitor_management_enabled = nextValue;

    this.apiService.editOrganization(record.id, { visitor_management_enabled: nextValue }).subscribe({
      next: (response: any) => {
        record.visitor_management_enabled = response.visitor_management_enabled;
        record.visitor_management_loading = false;
        this.toastr.success('Visitor management status updated.', 'Success');
      },
      error: (err) => {
        record.visitor_management_enabled = previousValue;
        record.visitor_management_loading = false;
        if (err?.error?.detail) {
          this.toastr.error(err.error.detail, 'Error');
        } else if (err?.error?.visitor_management_enabled) {
          this.toastr.error(err.error.visitor_management_enabled, 'Error');
        } else {
          this.toastr.error('Unable to update visitor management status.', 'Error');
        }
      }
    });
  }

    toggleParkingCapacity(record: any, event: Event) {
        const input = event.target as HTMLInputElement;
        const nextValue = input.checked;
        const previousValue = !!record.parking_capacity_enabled;
        record.parking_capacity_loading = true;
        record.parking_capacity_enabled = nextValue;

        this.apiService.editOrganization(record.id, {parking_capacity_enabled: nextValue}).subscribe({
            next: (response: any) => {
                record.parking_capacity_enabled = response.parking_capacity_enabled;
                record.parking_capacity_loading = false;
                this.toastr.success('Parking Capacity feature status updated.', 'Success');
            },
            error: (err) => {
                record.parking_capacity_enabled = previousValue;
                record.parking_capacity_loading = false;
                if (err?.error?.detail) {
                    this.toastr.error(err.error.detail, 'Error');
                } else if (err?.error?.parking_capacity_enabled) {
                    this.toastr.error(err.error.parking_capacity_enabled, 'Error');
                } else {
                    this.toastr.error('Unable to update Parking Capacity feature status.', 'Error');
        }
      }
    });
  }

    toggleDeviceHealthOfflineNotifications(record: any, event: Event) {
        const input = event.target as HTMLInputElement;
        const nextValue = input.checked;
        const previousValue = !!record.device_health_offline_notifications_enabled;
        record.device_health_offline_notifications_loading = true;
        record.device_health_offline_notifications_enabled = nextValue;

        this.apiService.editOrganization(record.id, {
            device_health_offline_notifications_enabled: nextValue,
        }).subscribe({
            next: (response: any) => {
                record.device_health_offline_notifications_enabled =
                    response.device_health_offline_notifications_enabled;
                record.device_health_offline_notifications_loading = false;
                this.toastr.success(
                    'Device Health offline notifications updated for Organization Admins.',
                    'Success',
                );
            },
            error: (err) => {
                record.device_health_offline_notifications_enabled = previousValue;
                record.device_health_offline_notifications_loading = false;
                if (err?.error?.detail) {
                    this.toastr.error(err.error.detail, 'Error');
                } else if (err?.error?.device_health_offline_notifications_enabled) {
                    this.toastr.error(err.error.device_health_offline_notifications_enabled, 'Error');
                } else {
                    this.toastr.error('Unable to update Device Health offline notifications.', 'Error');
                }
            }
        });
    }

    toggleOrganizationStatus(record: any, event: Event) {
        const input = event.target as HTMLInputElement;
        const nextValue = input.checked;
        const previousValue = record.is_active;
        record.status_loading = true;
        record.is_active = nextValue;

        this.apiService.editOrganization(record.id, {is_active: nextValue}).subscribe({
            next: (response: any) => {
                record.is_active = response.is_active;
                record.status_loading = false;
                this.toastr.success('Organization status updated.', 'Success');
            },
            error: (err) => {
                record.is_active = previousValue;
                record.status_loading = false;
                if (err?.error?.detail) {
                    this.toastr.error(err.error.detail, 'Error');
                } else if (err?.error?.is_active) {
                    this.toastr.error(err.error.is_active, 'Error');
                } else {
                    this.toastr.error('Unable to update organization status.', 'Error');
                }
            }
        });
    }
}
